module.exports = __webpack_public_path__ + "static/media/filename (19).d4b52fc4.png";